import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import currencyFormatter from 'currency-formatter';
import { FormGroup, Label, Col, FormFeedback } from 'reactstrap';

import CONST from '@shared/task/constants';
import { forms as Forms } from '@breezeway/brzw-components';

import './form_control_monetary.scss';

const EMPTY_STRING = '';

const FormControlMonetary = ({
  className,
  classNameContainer,
  currency,
  id,
  input,
  label,
  meta: { touched, error },
  placeholder,
  required,
}) => {
  const selectedCurrency = currencyFormatter.findCurrency(currency) || CONST.DEFAULT_CURRENCY;
  const { symbolOnLeft, symbol: currencySymbol } = selectedCurrency;
  const defaultPlaceholder = symbolOnLeft ? `${currencySymbol}0.00` : `0.00${currencySymbol}`;

  let validationState = null;
  let errorText = null;

  if (touched) {
    if (error) {
      validationState = 'danger';
      errorText = error;
    } else {
      validationState = 'success';
    }
  }

  return (
    <FormGroup
      color={validationState}
      className={classnames('form-control-monetary form-group-row', classNameContainer)}
    >
      <Label for={id} className="form-group-row__label">
        {required ? (
          <span>
            {label} <span className="text-orange">*</span>
          </span>
        ) : (
          label
        )}
      </Label>
      <Col className="form-group-row__col">
        <Forms.CurrencyInput
          className={classnames('form-control form-group-row__input', className)}
          id={id}
          placeholder={placeholder || defaultPlaceholder}
          prefix={symbolOnLeft ? currencySymbol : EMPTY_STRING}
          suffix={!symbolOnLeft ? currencySymbol : EMPTY_STRING}
          {...input}
        />
        <FormFeedback>{errorText}</FormFeedback>
      </Col>
    </FormGroup>
  );
};

FormControlMonetary.propTypes = {
  className: PropTypes.string,
  classNameContainer: PropTypes.string,
  currency: PropTypes.string,
  id: PropTypes.string,
  input: PropTypes.shape({}),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  meta: PropTypes.shape({}),
  placeholder: PropTypes.string,
  required: PropTypes.bool,
};

FormControlMonetary.defaultProps = {
  required: false,
};

export default FormControlMonetary;
